import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';

export const StyledButtonContainer = styled.button`
  position: relative;
  width: ${({width}) => (width)};
  height: ${({height}) => (height)};
  background: ${COLORS.mainColor};
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background: ${COLORS.mainColor_op7};
  }
`;

export const StyledLoaderContainer = styled.div`
  position: absolute;
  color: ${COLORS.white};
  width: max-content;
  font-size: ${({fs}) => (fs)};
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledLoader = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: block;
  margin:auto;
  position: relative;
  color: ${COLORS.white};
  box-sizing: border-box;
  animation: animloader 1s linear infinite alternate;


@keyframes animloader {
  0% {
    box-shadow: -38px -12px ,  -14px 0,  14px 0, 38px 0;
  }
  33% {
    box-shadow: -38px 0px, -14px -12px,  14px 0, 38px 0;
  }
  66% {
    box-shadow: -38px 0px , -14px 0, 14px -12px, 38px 0;
  }
  100% {
    box-shadow: -38px 0 , -14px 0, 14px 0 , 38px -12px;
  }
}
`;
